<template>
  <div
    class="coaches_carousel-container"
    style="overflow: clip"
  >
    <div class="coaches_carousel_nav">
      <div
        v-for="(item, idx) in items"
        :key="idx"
        class="coaches_carousel_nav_item"
        @click="scrollToIndex(idx)"
      >
        {{ item.nick }}
      </div>
    </div>
    <HorizolnalScroller
      ref="scroller"
      innerCssClass="coaches_carousel"
      :class="`cursor-${cursor}`"
      :style="`
          --arrow-width: ${mobile ? '1.25rem' : '4rem'};
          --arrow-size: 4rem;
          --arrow-height:var(--sld-height);
          --clr-arrow: var(--clr-grey-2);
          --arrow-left-inset:auto 5rem auto auto;
          --arrow-right-inset:auto -5rem auto auto;
          --clr-arrow-back:${mobile ? 'var(--clr-black-0)' : 'transparent'};
          --arrow-back-opacity:0;
        `"
    >
      <div class="coaches_carousel_items">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          class="coaches_carousel_item"
        >
          <CoachBox
            :ref="`item_${idx}`"
            :item="item"
            @mouseenter="toggleCursor"
          />
        </div>
      </div>
    </HorizolnalScroller>
  </div>
</template>

<script>
import CoachBox from '@/components/lib/CoachBox'
import { allCoaches } from '@/helpers/coachings'
import HorizolnalScroller from '@/components/HorizolnalScroller/HorizolnalScroller'

export default {
  name: 'CoachesSlideshow',
  components: {
    CoachBox,
    HorizolnalScroller,
  },
  props: {},
  data() {
    return {
      intervalID: 0,
      time: 12000,
      slideshowIndex: 0,
      cursor: 'club',
      cIdx: 0,
    }
  },
  created() {
    this.reset()
  },
  beforeUnmount() {
    clearInterval(this.intervalID)
  },
  methods: {
    toggleCursor() {
      const cursors = ['spade', 'club', 'diamond', 'heart']
      this.cIdx = this.cIdx + 1 === cursors.length ? 0 : this.cIdx + 1
      this.cursor = cursors[this.cIdx]
    },
    scrollToIndex(idx) {
      const c = this.$refs[`item_${idx}`]
      // debugger
      // console.log(c)
      if (c) {
        c[0].$el.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        })
      }
    },
    reset(index = 0) {
      // console.log(this.items)
      clearInterval(this.intervalID)
      this.slideshowIndex = index
      this.startSlideshow()
    },
    startSlideshow() {
      this.intervalID = setInterval(() => {
        const index = this.slideshowIndex + 1
        this.slideshowIndex = index > this.items.length - 1 ? 0 : index
      }, this.time)
    },
  },
  computed: {
    items() {
      let res = allCoaches()
      // let res = opts[this.gm_type]
      res = res.map(i => ({
        ...i,
        fullname: this.$t(`coaches.${i.id}.fullname`),
        name_nick: this.$t(`coaches.${i.id}.name_nick`),
        nick: this.$t(`coaches.${i.id}.nick`),
        bio: this.$t(`coaches.${i.id}.${i.i18n_key_bio || 'bio'}`),
      }))
      // res = [...res, ...res, ...res]
      // console.log(res)
      return res
    },
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
  },
}
</script>

<style lang="scss">
.cursor-spade {
  cursor: url('@/assets/cursors/spade.webp'), auto;
}
.cursor-club {
  cursor: url('@/assets/cursors/club.webp'), auto;
}
.cursor-diamond {
  cursor: url('@/assets/cursors/diamond.webp'), auto;
}
.cursor-heart {
  cursor: url('@/assets/cursors/heart.webp'), auto;
}
.coaches {
  &_carousel {
    display: flex;
    // --sld-height: 510px;
    // --sld-height: 100%;
    --sld-item-width: 20.5rem;
    height: var(--sld-height);
    max-height: var(--sld-height);
    &_items {
      display: flex;
      margin: 0 auto;
      grid-gap: 1.75rem;
      height: var(--sld-height);
      max-height: var(--sld-height);
    }
    &_item {
      width: var(--sld-item-width);
      height: var(--sld-height);
      max-height: var(--sld-height);

      // background: red;
      // margin-left: 1.25rem;
    }
    &_nav {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.75rem;
      flex-wrap: wrap;
      margin: auto;
      // max-width: 68rem;
      &_item {
        white-space: nowrap;
        padding: 0rem 0.5rem 1rem 0.5rem;
        // font-size: 0.875rem;
        // font-size: 1.25rem;
        font-size: 1rem;
        font-weight: 500;
        color: var(--clr-grey-2);
        cursor: pointer;
        &:hover {
          color: var(--clr-white-0);
        }
      }
    }
  }
}
</style>
